<script setup lang="ts">
import { Link } from "@inertiajs/vue3"

defineProps<{
  title: string
  subtitle?: string
  backHref: string
  backLabel?: string
}>()
</script>

<template>
  <section class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <div class="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 class="text-2xl font-semibold text-slate-900">{{ title }}</h1>
        <p v-if="subtitle" class="mt-1 text-sm text-slate-600">{{ subtitle }}</p>
      </div>

      <Link :href="backHref" class="rounded-md border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100">
        {{ backLabel ?? "Voltar" }}
      </Link>
    </div>

    <slot />
  </section>
</template>

